import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useArtistAuth } from '@/context/ArtistAuthContext';

const ProtectedArtistRoute = () => {
  const { loading, isAuthenticated } = useArtistAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="bg-white rounded-3xl shadow-xl px-8 py-10 text-center max-w-md w-full">
          <div className="w-12 h-12 mx-auto mb-4 rounded-full border-4 border-[#FF6F00] border-t-transparent animate-spin" />
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Checking your session</h1>
          <p className="text-gray-600">Please wait while we load your artist account.</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default ProtectedArtistRoute;
